/* global videojs, YT, videoID */

import $ from 'jquery';
import overlay from './overlay';

let $poster;
let $topVideoWrap;
let $body;
let vendorPath;

function appendScript(src) {
  src = $.isArray(src) ? src : [src];

  $.each(src, (i, el) => {
    const script = document.createElement('script');

    script.src = el;
    $body.append(script);
  });
}

function prepareDesktop() {
  appendScript([
    `${vendorPath}videojs.js`,
    `${vendorPath}videojs-youtube.js`,
  ]);

  const player = videojs('#vid1', {
    controlBar: {
      volumeMenuButton: false,
      fullscreenToggle: false,
      currentTimeDisplay: false,
      durationDisplay: false,
      remainingTimeDisplay: false,
    },
    Youtube: {
      modestbranding: 1,
    },
  });

  const videoOverlay = $('.video__overlay');
  const close = videoOverlay.find('.video__overlay-close');

  overlay.init(videoOverlay);
  overlay.resize(videoOverlay);

  $poster.on('click', () => {
    videoOverlay.show();
    $('#vid1').removeClass('hidden'); // musi być bez cache

    if (document.getElementsByClassName('no-touch').length) {
      player.play();
    }
  });

  close.off().on('click', () => {
    videoOverlay.hide();
    player.pause();
  });
}

function prepareMobile() {
  let player;
  const $iframeWrap = $('<div class="video__iframe-wrap hidden"><div id="player"></div></div>');
  const tag = document.createElement('script');
  const firstScriptTag = document.getElementsByTagName('script')[0];

  $topVideoWrap.append($iframeWrap);

  tag.src = '//www.youtube.com/iframe_api';
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  function onYouTubeIframeAPIReady() {
    player = new YT.Player('player', {
      height: '390',
      width: '640',
      videoId: videoID,
    });
  }

  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

  $poster.on('click', () => {
    $poster.addClass('hidden');
    $iframeWrap.removeClass('hidden');
    player.playVideo();
  });
}

function init() {
  $poster = $('.function__video').find('img').addClass('function__video--pointer');
  $topVideoWrap = $('.function__video');
  $body = $('body');
  vendorPath = '/static/front/iko-app-lite/js/vendor/';

  if (document.getElementsByClassName('no-touch').length) {
    prepareDesktop();
  } else {
    prepareMobile();
  }
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/video.js